import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventLoader } from 'src/domains/sportsbook/webview/components/loaders/EventLoader';
import { MatchCardLoaderWrapper, SecondaryHeaderLoader } from 'src/domains/layouts/shared/loaders';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const MatchCardLoader = observer('EventsTableMarketsLoader', (): JSX.Element => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { sportsbookVariant } = configState.componentVariants;
    const fourEventRows = [];

    for (let i = 0; i < 4; i++) {
        fourEventRows.push(<EventLoader key={i} />);
    }

    return (
        <MatchCardLoaderWrapper>
            <SecondaryHeaderLoader
                size='small'
                variant={sportsbookVariant}
            />
            {fourEventRows}
        </MatchCardLoaderWrapper>
    );
});
